import Link from "next/link";
import Course from "../types/Course";
import {FCWithHTMLAttributes} from "../types/reactTypes";
import clsMerge from "../util/clsMerge";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/sharp-solid-svg-icons/faArrowRight";
import {getCoursePath} from "../util/urlUtils";
const CourseButton: FCWithHTMLAttributes<{course: Course}> = ({
	course: {name, slug},
	className,
}) => {
	return (
		<Link
			href={getCoursePath(slug)}
			className={clsMerge(
				"group relative flex cursor-pointer justify-between gap-6 rounded-md border-1 border-gray-400 bg-white px-4 py-3 text-sm transition-colors duration-300 hover:bg-gray-50 md:hover:shadow-lg",
				className
			)}
		>
			<span className="group-hover:underline">{name}</span>
			<div className="w-5">
				<span className="transition-opacity duration-300 group-hover:opacity-100 md:opacity-0">
					<FontAwesomeIcon icon={faArrowRight} />
				</span>
			</div>
		</Link>
	);
};

export default CourseButton;
